import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { getGallery, getGalleryCache } from "../services";
import IFHeading from "../components/IF_Heading.jsx";

function Foto({ data }) {
    return (
        <div className="relative w-full h-full rounded-2xl overflow-hidden bg-[#12141e] border border-white/10 hover:border-pink transition-colors duration-200 group">
            <img
                loading="lazy"
                alt={data.name || "Galeri Aktivitas I-FIT Indonesia"}
                src={process.env.REACT_APP_IMAGE_ALBUM_URL + data.filename}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
        </div>
    );
}

function Film({ data }) {
    return (
        <div className="rounded-2xl overflow-hidden w-full h-full bg-black border border-pink/30 flex items-center justify-center">
            <video
                preload="metadata"
                controls
                playsInline
                className="w-full h-full object-cover"
            >
                <source
                    src={`${process.env.REACT_APP_IMAGE_ALBUM_URL + data.filename}#t=1`}
                    type="video/mp4"
                />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}

function LocalTabPanel({ datas = [] }) {
    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5 pt-6">
            {datas.map((data, i) => (
                <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8, delay: (i % 8) * 0.08, ease: "linear" }}
                    whileHover={{ y: -6 }}
                    className="w-full aspect-square"
                >
                    {data.type === "image" ? (
                        <Foto data={data} />
                    ) : (
                        <Film data={data} />
                    )}
                </motion.div>
            ))}
        </div>
    );
}

export default function Gallery() {
    const cached = getGalleryCache();
    const [activeTab, setActiveTab] = useState(0);
    const [data, setDatas] = useState(() => cached || {
        studio: [],
        gymManagement: [],
        certification: [],
    });
    const [load, setLoad] = useState(() => !cached || (!cached.studio?.length && !cached.gymManagement?.length && !cached.certification?.length));

    useEffect(() => {
        getGallery().then((res) => {
            if (res) setDatas(res);
            setLoad(false);
        });
    }, []);

    if (load) {
        return (
            <div className="min-h-[70vh] w-full flex items-center justify-center">
                <div className="w-12 h-12 rounded-full border-4 border-white/20 border-t-pink animate-spin" />
            </div>
        );
    }

    const tabList = [
        { label: "I-FIT STUDIO", data: data.studio },
        { label: "GYM MANAGEMENT", data: data.gymManagement },
        { label: "CERTIFICATIONS", data: data.certification },
    ];

    return (
        <div className="w-full pt-[130px] lg:pt-[160px] pb-16 md:pb-24 overflow-x-hidden">
            <IFHeading as="h1">GALLERY & MOMENTS</IFHeading>

            <div className="max-w-[1300px] mx-auto mt-8 px-4 md:px-8">
                {/* Custom Tab List */}
                <div className="flex justify-center">
                    <div className="p-1.5 rounded-full bg-[#12141e] border border-white/10 inline-flex flex-wrap justify-center gap-2">
                        {tabList.map((tab, idx) => {
                            const isSelected = activeTab === idx;
                            return (
                                <button
                                    key={tab.label}
                                    type="button"
                                    onClick={() => setActiveTab(idx)}
                                    className={`relative px-4 sm:px-6 py-2 rounded-full text-xs sm:text-sm font-extrabold tracking-wider transition-colors duration-200 cursor-pointer ${isSelected
                                            ? "bg-gradient-to-r from-pink to-ungu text-white"
                                            : "text-gray-300 hover:text-white hover:bg-white/5"
                                        }`}
                                >
                                    {tab.label}
                                </button>
                            );
                        })}
                    </div>
                </div>

                {/* Tab Panel Content */}
                <div className="mt-6">
                    <LocalTabPanel datas={tabList[activeTab].data} />
                </div>
            </div>
        </div>
    );
}
